import { Injectable } from '@angular/core';
import { ApiClient } from '../core/api-client.service';
import { Observable } from 'rxjs';
import { DumbMemberListItem } from './DTOs/dumb-member-list-item';
import { MembersDtRetInfo } from './DTOs/members-dt-ret-info';
import { GetMemberListRequest } from './DTOs/get-member-list-request';
import { GetDiscountListRequest } from './DTOs/get-discount-list-request';
import { DiscountsDtRetInfo } from './DTOs/discounts-dt-ret-info';
import { DumbMemberDiscount } from '../public-portal/member-information/DTOs/dumb-member-discount';
import { AddEditChamberPerkRequest } from './DTOs/add-edit-chamber-perk-request';
import { DumbCompanyDetails } from './DTOs/dumb-company';
import { DumbLiaison } from './DTOs/dumb-liaison';
import { DumbCompanyAddress } from './DTOs/dumb-company-address';
import { UpdatePaymentInfoRequest } from './DTOs/update-payment-info-request';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminMemberManagementService {
  readonly relativeBase = "super-admin-member-management/";


  constructor(private http: ApiClient) {

  }

  getMembersList(request: GetMemberListRequest): Observable<MembersDtRetInfo> {
    return this.http.post(this.relativeBase + "get-all", request);
  }
  getDiscountsList(request: GetDiscountListRequest): Observable<DiscountsDtRetInfo> {
    return this.http.post(this.relativeBase + "chamber-perks/get-all", request);
  }
  getDiscountDetails(discountId: number): Observable<DumbMemberDiscount> {
    return this.http.get(this.relativeBase + "chamber-perks/details/" + discountId);
  }
  addChamberPerk(request: AddEditChamberPerkRequest): Observable<DiscountsDtRetInfo> {
    return this.http.put(this.relativeBase + "chamber-perks/add", request);
  }
  editChamberPerk(request: AddEditChamberPerkRequest): Observable<DumbMemberDiscount> {
    return this.http.post(this.relativeBase + "chamber-perks/edit", request);
  }
  getCompanyDetails(memberId: string): Observable<DumbCompanyDetails> {
      return this.http.get(this.relativeBase + "get-company-details/" + memberId);
  }
  UpdateCompanyLiaison(request: DumbLiaison, memberId: string) {
      return this.http.post(this.relativeBase + "update-liaison/" + memberId, request);
  }
  UpdateCompanyDetails(request: DumbCompanyDetails, memberId: string) {
      return this.http.post(this.relativeBase + "update-company-details/" + memberId, request);
  }
  AddUpdateCompanyAddress(request: DumbCompanyAddress,memberId: string, adding: boolean) {
      return this.http.post(this.relativeBase + `update-address/${memberId}/${adding}` , request);
  }
  SendMemberPasswordReset(contactId: string) {
    return this.http.post(this.relativeBase + "send-passord-reset/" + contactId, null);
    }
UpdateCompanyPaymentInfo(request: UpdatePaymentInfoRequest) {
    return this.http.post(this.relativeBase + "update-company-payment-details", request);
}
uploadLogoFile(formData: FormData) {
    return this.http.post(this.relativeBase + "upload-logo", formData);
    }
    UpdateCompanyDirectoryDetails(request: DumbCompanyDetails, memberId: string) {
        return this.http.post(this.relativeBase + "update-directory-details/" + memberId, request);
    }
}
